import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../hook/useAuth'
import Cookies from 'js-cookie'

const RequireAuth = ({children}) => {
    const location = useLocation();
    const {userData} = useAuth();

    if (!Cookies.get('token')) { 
        
        // console.log(window.history.state)
        
        return <Navigate to='/connexion'  />
    }

  return children;
}

export {RequireAuth};